import React from 'react';
import { portalDs } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';
import { QuestionStats } from 'src/redux/survey/survey.types';

interface OverviewSidepanelQuestionProps {
  index: number;
  question: QuestionStats;
  isActive?: boolean;
  onClick?: () => void;
}

const OverviewSidepanelQuestion: React.FC<OverviewSidepanelQuestionProps> = ({
  index,
  question,
  isActive = false,
  onClick,
}) => {
  return (
    <button
      type="button"
      className={cn(
        'flex w-full items-start gap-2 rounded-lg px-2 py-2 text-left transition-colors hover:bg-[#F0F1F5]',
        isActive && 'bg-[#EFF6FF]',
      )}
      onClick={onClick}
    >
      <span className="flex size-5 shrink-0 items-center justify-center rounded-md bg-[#EFF6FF] text-[11px] font-bold text-[#2563EB]">
        {index + 1}
      </span>
      <span className={cn(portalDs.bodySm, 'line-clamp-2 text-[#0D0F1A]')}>
        {question.title}
      </span>
    </button>
  );
};

export default OverviewSidepanelQuestion;
